import styled from 'styled-components';

import { StrongText } from '@dreryk/react-components';

export const ConfidentialDataAccessDescriptionLeadingText = styled(StrongText)`
   display: inline;
`;
